import * as React from 'react';
import ParameterLayout from "./parameterLayout";

const TextParameter = (props) => {
    return (
        <ParameterLayout parameter={props.parameter} type={props.type} description={props.description} required={props.required} disable={props.disable}>
            <input className="form-control"
                   name="path" value={props.value} onChange={(e)=>props.onChange(e)} placeholder={props.placeholder}/>
        </ParameterLayout>
    )
}

export default TextParameter;